export enum PricingType {
    FIXED = 'fixed', SCALED = 'scaled'
}
